import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { useShallow } from 'zustand/shallow'
import { Slot } from '@/app/constants/slot'
import { zustandPlugin } from '@/modules/shared/openreplay'

type ActivityPagesTypes =
  | 'daily'
  | 'weekly'
  | 'monthly'
  | 'yearly'
  | 'time'
  | 'cardData'
  | 'details'

type State = {
  type: ActivityPagesTypes
  speedChartSelected: boolean
  slot: Slot
}

type Actions = {
  setType: (d: ActivityPagesTypes) => void
  setSpeedChartSelected: (selected: boolean) => void
  setSlot: (slot: Slot) => void
}

export const useVehicleActivityStore = create<State & Actions>()(
  devtools(
    zustandPlugin((set) => ({
      type: 'daily',
      speedChartSelected: false,
      slot: Slot.Driver,
      setType: (type) => set({ type }, false, 'setType'),
      setSpeedChartSelected: (speedChartSelected) =>
        set(
          { speedChartSelected },
          false,
          'setSpeedChartSelected',
        ),
      setSlot: (slot) => set({ slot }, false, 'setSlot'),
    }), 'vehicle-activity'),
    { name: 'EasyTacho', store: 'vehicle-activity' },
  ),
)

export const useActivity = () =>
  useVehicleActivityStore(
    useShallow((s) => ({
      type: s.type,
      setType: s.setType,
      speedChartSelected: s.speedChartSelected,
      setSpeedChartSelected: s.setSpeedChartSelected,
      slot: s.slot,
      setSlot: s.setSlot,
    })),
  )
